import {
  UI_REQUEST,
  UI_SUCCESS,
  UI_ERROR,
  UI_FREE_DATA,
  UI_INIT_APPLICATION,
  UI_FREE_APPLICATION,
  UI_INIT_UI,
  UI_SET_MODULE,
  UI_SET_MODULES,
  UI_SET_ACTIONS,
  UI_ADD_ACTION,
  UI_DEL_ACTION,
  UI_SET_ACTION_PARAMS,
  UI_INVOKE_ACTION,
  UI_INVOKE_REPORT,
  UI_SNACKBAR,
  UI_ALLOW_LONGPOLL

} from '../actions/ui'
import axios from 'axios'
import { USER_FREE_DATA, USER_REQUEST } from '../actions/user'
import { HRCV_FREE_DATA } from '../actions/hrcv'
import { BLOG_FREE_DATA } from '../actions/blog'
import { CLM_DATA_LONGPOLL, CLM_FREE_DATA } from '../actions/claims'
import { ORG_PROFILE_REQUEST, ORG_FREE_DATA } from '@/store/actions/org'
import { REQ_GET_DOC_STATUS_LIST, REQ_FREE_DATA } from '@/store/actions/request'
import { RCPT_FREE_DATA } from '../actions/receptures'
import { CALC_FREE_DATA } from '../actions/calculations'

const state = {
  longpollsActive: false,
  userModules: [],
  currentModule: {},
  currentActions: [],
  currentReports: [],
  snackBar: {
    text: '',
    color: ''
  },
  uiConf: {},
  ordersTab: 0,
  status: '',
  sysStatus: {
    requests: [],
    status () {
      return this.requests.length === 0 ? 'idle' : 'busy'
    },
    tasks () {
      return this.requests.map(item => item.task)
    }
  }
}

const getters = {
  getUserModules: state => state.userModules,
  getCurrentActions: state => state.currentActions,
  getCurrentActionListState: state => state.status,
  getCurrentOrdersTab: state => state.ordersTab,
  getSystemStatus: state => state.status,
  getSnackBar: state => state.snackBar,
  getUIStatus: state => {
    return state.sysStatus.status()
  },
  getUITasks: state => {
    return state.sysStatus.tasks()
  },
  getUIConf: state => {
    return state.uiConf
  },
  getDefaultPath: state => {
    console.log('Current modules are ', state.userModules)
    return state.userModules.length ? state.userModules[0].FM_PATH : '/login'
  },
  getLongpollsActive: state => state.longpollsActive
}
const actions = {
  [UI_REQUEST]: ({ commit }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, params)
      resolve()
    }),
  [UI_SUCCESS]: ({ commit }, params) =>
    new Promise((resolve) => {
      commit(UI_SUCCESS, params)
      resolve()
    }),
  [UI_ERROR]: ({ commit }, params) =>
    new Promise((resolve) => {
      commit(UI_ERROR, params)
      resolve()
    }),
  [UI_INIT_UI]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(UI_REQUEST, { action: 'UI_INIT_UI', topic: 'Инициализация интерфейса', error: null })
      axios({ url: '/api/org/initUI.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(UI_INIT_UI, resp.data.data)
            commit(UI_SUCCESS, { action: 'UI_INIT_UI' })
            resolve(resp.data.data)
          } else {
            commit(UI_ERROR, { action: 'UI_INIT_UI', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          commit(UI_ERROR, { action: 'UI_INIT_UI', result: err })
          reject(new Error(err))
        })
    }),
  [UI_INIT_APPLICATION]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      console.log('Initializing application state')
      dispatch(ORG_FREE_DATA)
      commit(UI_ALLOW_LONGPOLL, 'on')
      commit(UI_REQUEST, { action: 'UI_INIT_APPLICATION', topic: 'Инициализация приложения', error: null })
      // Init user
      dispatch(USER_REQUEST)
        .then((user) => {
          console.log('User initialization complete', user)
          // Init organisation profile
          dispatch(ORG_PROFILE_REQUEST)
            .then((orgprofile) => {
              console.log('Organization initialization complete', orgprofile)
              // Init common lists
              dispatch(REQ_GET_DOC_STATUS_LIST)
                .then((statusList) => {
                  console.log('Document status list initialization complete', statusList)
                  resolve(statusList)
                })
                .catch((err) => {
                  console.log('Document states initialization error')
                  commit(UI_ERROR, { action: 'UI_INIT_APPLICATION', result: err })
                  reject(err)
                })
            })
            .catch((err) => {
              console.log('Organization initialization error')
              commit(UI_ERROR, { action: 'UI_INIT_APPLICATION', result: err })
              reject(err)
            })
          dispatch(CLM_DATA_LONGPOLL)
          commit(UI_SUCCESS, { action: 'UI_INIT_APPLICATION' })
        })
        .catch((err) => {
          console.log('User initialization error')
          commit(UI_ERROR, { action: 'UI_INIT_APPLICATION', result: err })
          reject(err)
        })
    }),
  [UI_FREE_APPLICATION]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      console.log('Deinitializing application')
      commit(UI_REQUEST, { action: 'UI_FREE_APPLICATION', topic: 'Завершение приложения', error: null })
      dispatch(UI_ALLOW_LONGPOLL, 'off')
      // DeInit org module
      dispatch(ORG_FREE_DATA)
        .then((orgRes) => {
          console.log('ORG module deininitialized', orgRes)
          // DeInit request module
          dispatch(REQ_FREE_DATA)
            .then((reqRes) => {
              console.log('REQUEST module deinitialized', reqRes)
              // DeInit user
              dispatch(USER_FREE_DATA)
                .then((usrRes) => {
                  console.log('USER module deinitialized', usrRes)
                  resolve('success')
                })
                .catch((err) => {
                  console.log('USER module deinitialization error')
                  commit(UI_ERROR, { action: 'UI_FREE_APPLICATION', result: err })
                  reject(err)
                })
              commit(HRCV_FREE_DATA)
              commit(BLOG_FREE_DATA)
              commit(CLM_FREE_DATA)
              commit(CALC_FREE_DATA)
              commit(RCPT_FREE_DATA)
              commit(UI_FREE_DATA)
              resolve('success')
            })
            .catch((err) => {
              console.log('REQUEST module deinitialization error')
              commit(UI_ERROR, { action: 'UI_FREE_APPLICATION', result: err })
              reject(err)
            })
          commit(UI_SUCCESS, { action: 'UI_FREE_APPLICATION' })
        })
        .catch((err) => {
          console.log('ORG module deininitialization error')
          commit(UI_ERROR, { action: 'UI_FREE_APPLICATION', result: err })
          reject(err)
        })
    }),
  [UI_SET_MODULES]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_SET_MODULES', topic: 'Установка списка доступных модулей', error: null })
      commit(UI_SET_MODULES, params || [])
      commit(UI_SUCCESS, { action: 'UI_SET_MODULES' })
      resolve()
    }),
  [UI_SET_MODULE]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_SET_MODULE', topic: 'Установка модуля', error: null })
      commit(UI_SET_MODULE, params)
      commit(UI_SUCCESS, { action: 'UI_SET_MODULE' })
      resolve()
    }),
  [UI_SET_ACTIONS]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_SET_ACTIONS', topic: 'Установка действий', error: null })
      commit(UI_SET_ACTIONS, params)
      commit(UI_SUCCESS, { action: 'UI_SET_ACTIONS' })
      resolve()
    }),
  [UI_INVOKE_REPORT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(UI_REQUEST, { action: 'UI_INVOKE_REPORT', topic: 'Создание отчёта', error: null })
      axios({ url: '/api/org/orders/getProposalReport.php', data: params, method: 'POST', responseType: 'blob' })
        .then(resp => {
          commit(UI_SUCCESS, { action: 'UI_INVOKE_REPORT', topic: 'Создание отчёта', error: null })
          resolve(resp)
        })
        .catch((err) => {
          commit(UI_ERROR, { action: 'UI_INVOKE_REPORT', result: err })
          reject(new Error(err))
        })
    }),
  [UI_ADD_ACTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_ADD_ACTION', topic: 'Установка действия', error: null })
      commit(UI_ADD_ACTION, params)
      commit(UI_SUCCESS, { action: 'UI_ADD_ACTION' })
      resolve()
    }),
  [UI_DEL_ACTION]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_DEL_ACTION', topic: 'Удаление действия', error: null })
      commit(UI_DEL_ACTION, params)
      commit(UI_SUCCESS, { action: 'UI_DEL_ACTION' })
      resolve()
    }),
  [UI_SET_ACTION_PARAMS]: ({ commit, dispatch }, params) =>
    new Promise((resolve) => {
      commit(UI_REQUEST, { action: 'UI_SET_ACTION_PARAMS', topic: 'Установка параметров действия', error: null })
      commit(UI_SET_ACTION_PARAMS, params)
      commit(UI_SUCCESS, { action: 'UI_SET_ACTION_PARAMS' })
      resolve()
    }),
  [UI_INVOKE_ACTION]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      commit(UI_REQUEST, { action: 'UI_INVOKE_ACTION', topic: 'Исполнение действия', error: null })
      const typeIndex = state.currentActions.findIndex(item => item.actionType === params.actionType)
      if (typeIndex >= 0) {
        const actionIndex = state.currentActions[typeIndex].actions.findIndex(item => item.action === params.action)
        if (actionIndex >= 0) {
          const method = state.currentActions[typeIndex].actions[actionIndex].method
          const fParams = state.currentActions[typeIndex].actions[actionIndex].params
          let result
          if (typeof method === 'function') {
            try {
              result = method(fParams)
              resolve(result)
            } catch (e) {
              reject(e.message)
            } finally {
              commit(UI_SUCCESS, { action: 'UI_INVOKE_ACTION' })
            }
          } else {
            console.log('Action substituted method is not a function ', params)
            const err = new Error('Ошибка исполнения действия ' + params)
            commit(UI_ERROR, { action: 'UI_INVOKE_ACTION', result: err })
            reject(err)
          }
        } else {
          console.log('Action not found ', params)
          const err = new Error('Ошибка исполнения действия ' + params)
          commit(UI_ERROR, { action: 'UI_INVOKE_ACTION', result: err })
          reject(err)
        }
      } else {
        console.log('Type not found ', params)
        const err = new Error('Не найден тип действия ' + params)
        commit(UI_ERROR, { action: 'UI_INVOKE_ACTION', result: err })
        reject(err)
      }
    }),
  [UI_ALLOW_LONGPOLL]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(UI_ALLOW_LONGPOLL, params)
      resolve(state.longpollsActive)
    })
}

const mutations = {
  [UI_INIT_UI]: (state, resp) => {
    state.uiConf = resp
  },
  [UI_SNACKBAR]: (state, resp) => {
    console.log('UI_SNACKBAR mutation initiated, ', resp)
    state.snackBar.text = resp.text
    state.snackBar.color = resp.color
  },
  [UI_REQUEST]: (state, resp) => {
    state.status = 'loading'
    state.sysStatus.requests.push(resp)
  },
  [UI_SUCCESS]: (state, resp) => {
    state.status = 'success'
    const reqIndex = state.sysStatus.requests.findIndex(req => req.action === resp.action)
    if (reqIndex !== -1) {
      state.sysStatus.requests.splice(reqIndex, 1)
    }
  },
  [UI_ERROR]: (state, resp) => {
    state.status = 'error'
    const reqIndex = state.sysStatus.requests.findIndex(req => req.action === resp.action)
    if (reqIndex !== -1) {
      if (state.sysStatus.requests[reqIndex].error) {
        state.sysStatus.requests[reqIndex].error(resp.result)
      }
      state.sysStatus.requests.splice(reqIndex, 1)
    }
  },
  [UI_FREE_DATA]: state => {
    state.status = ''
    state.currentModule = {}
    state.userModules.splice(0, state.userModules.length)
    state.currentActions.splice(0, state.currentActions.length)
    state.currentReports.splice(0, state.currentReports.length)
  },
  [UI_SET_MODULE]: (state, resp) => {
    state.status = 'success'
    console.log('UI_SET_MODULE mutation initiated, ', resp)
    state.currentModule = resp
  },
  [UI_SET_MODULES]: (state, resp) => {
    state.status = 'success'
    console.log('UI_SET_MODULES mutation initiated, ', resp)
    state.userModules.splice(0, state.userModules.length, ...resp)
  },
  [UI_SET_ACTIONS]: (state, resp) => {
    state.status = 'success'
    const typeIndex = state.currentActions.findIndex(item => item.actionType === resp.actionType)
    if (typeIndex >= 0) {
      (resp.actions && resp.actions.length > 0) ? state.currentActions[typeIndex].actions.splice(0, state.currentActions[typeIndex].actions.length, ...resp.actions) : state.currentActions.splice(typeIndex, 1)
      return
    }
    if (resp.actionType === 'all' || !resp.actionType) {
      state.currentActions.splice(0, state.currentActions.length)
      return
    }

    if (resp.actions && resp.actions.length > 0) {
      state.currentActions.push(resp)
    }
  },
  [UI_ADD_ACTION]: (state, resp) => {
    state.status = 'success'
    const typeIndex = state.currentActions.findIndex(item => item.actionType === resp.actionType)
    if (typeIndex < 0) {
      const item = {
        actionType: resp.actionType,
        actions: []
      }
      const idx = state.currentActions.push(item)
      state.currentActions[idx - 1].actions.push(resp)
    } else {
      const actionIndex = state.currentActions[typeIndex].actions.findIndex(item => item.action === resp.action)
      if (actionIndex < 0) {
        state.currentActions[typeIndex].actions.push(resp)
      }
    }
  },
  [UI_DEL_ACTION]: (state, resp) => {
    state.status = 'success'
    console.log('UI_DEL_ACTION mutation initiated, ', resp)
    const typeIndex = state.currentActions.findIndex(item => item.actionType === resp.actionType)
    if (typeIndex >= 0) {
      const actionIndex = state.currentActions[typeIndex].actions.findIndex(item => item.action === resp.action)
      if (actionIndex >= 0) {
        state.currentActions[typeIndex].actions.splice(actionIndex, 1)
      }
    }
  },
  [UI_SET_ACTION_PARAMS]: (state, resp) => {
    state.status = 'success'
    console.log('UI_SET_ACTION_PARAMS mutation initiated, ', resp)
    const typeIndex = state.currentActions.findIndex(item => item.actionType === resp.actionType)
    if (typeIndex >= 0) {
      const actionIndex = state.currentActions[typeIndex].actions.findIndex(item => item.action === resp.action)
      if (actionIndex >= 0) {
        state.currentActions[typeIndex].actions[actionIndex].params = resp.params
      }
    }
  },
  [UI_ALLOW_LONGPOLL]: (state, resp) => {
    state.status = 'success'
    console.log('UI_ALLOW_LONGPOLL mutation initiated, ', resp)
    if (resp === 'on') {
      state.longpollsActive = true
    }
    if (resp === 'off') {
      state.longpollsActive = false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
